import api from '@/lib/api'

export default {
  namespaced: true,
  state: {
    companyProductList: {
      productList: [],
      productListRowCount: 0,
    },
    companyServiceList: {
      serviceList: [],
      serviceListRowCount: 0,
    },
    companyDetails: {
      headerInfo: [],
      generalInfo:[],
      awardList:[],
      branchList:[],
      certificateList:[],
      productList:[],
      serviceList:[]
    }
  },
  mutations: {
    setCompany(state, company) {
      state.companyDetails = company;
    },
    setCompanyProductList(state, products) {
      state.companyProductList = products;
    },
    setCompanyServiceList(state, services) {
      state.companyServiceList = services;
    },
  },
  actions: {
    async fetchCompany({ commit }, { companyId }) {
      const response = await api.getCompany(companyId) 

      //console.log('fetchCompany ::: :', response);
      commit('setCompany', {
        headerInfo: response.data.headerInfo,
        awardList: response.data.awardList,
        branchList: response.data.branchList,
        certificateList: response.data.certificateList,
        corporateList: response.data.corporateList,
        productList: response.data.productList,
        serviceList: response.data.serviceList,
        generalInfo: response.data.generalInfo
      })
    },
    async fetchCompanyProductList({ commit }, { companyId
     , searchKey, RowsPerPage, PageNumber 
    }) {
      const response = await api.getCompanyProductList(companyId,searchKey,RowsPerPage,PageNumber);   
      commit('setCompanyProductList', {productList: response.data.productList, productListRowCount: response.data.pageInfo ? response.data.pageInfo.RowCount: 0});
    },
    async fetchCompanyServiceList({ commit }, { companyId
      , searchKey, RowsPerPage, PageNumber 
     }) {
       const response = await api.getCompanyServiceList(companyId,searchKey,RowsPerPage,PageNumber);   
       commit('setCompanyServiceList', {serviceList: response.data.serviceList, serviceListRowCount: response.data.pageInfo? response.data.pageInfo.RowCount: 0});
     },
  },
  
}
